import { transactionConstants } from '../constants';

export function transactions(state = {}, action) {
  switch (action.type) {
    case transactionConstants.GETALL_REQUEST:
      return {
        state,
        loading: true
      }
    case transactionConstants.GETALL_SUCCESS:
      return {
        ...state,
        items: action.items,
        total: action.total,
        loading: false
      }
    case transactionConstants.GETALL_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false
      };
    default:
      return state;
  }
}